function serializePredictionParams(opts) {
    return [
        opts.input,
        opts.locale,
    ].join('-');
}

export {
    serializePredictionParams,
};
